export default __webpack_public_path__ + "static/media/addIcon.b0493d26.svg";